"use strict";

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Helper functions for digest

function objectDigest(obj) {
  return obj ? [obj.classID, obj._id] : null;
}

exports.objectDigest = objectDigest;

var Action =
/*#__PURE__*/
function () {
  function Action() {
    _classCallCheck(this, Action);
  }

  _createClass(Action, [{
    key: "dispatch",
    value: function dispatch(dispatcher) {
      dispatcher.dispatch(this);
    }
  }, {
    key: "digest",
    value: function digest() {
      return {
        name: this.constructor.name
      };
    }
  }]);

  return Action;
}();

exports.Action = Action;

var SelectMark =
/*#__PURE__*/
function (_Action) {
  _inherits(SelectMark, _Action);

  function SelectMark(plotSegment, glyph, mark) {
    var _this;

    var glyphIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    _classCallCheck(this, SelectMark);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectMark).call(this));
    _this.plotSegment = plotSegment;
    _this.glyph = glyph;
    _this.mark = mark;
    _this.glyphIndex = glyphIndex;
    return _this;
  }

  _createClass(SelectMark, [{
    key: "digest",
    value: function digest() {
      return {
        name: "SelectMark",
        plotSegment: objectDigest(this.plotSegment),
        glyph: objectDigest(this.glyph),
        mark: objectDigest(this.mark),
        glyphIndex: this.glyphIndex
      };
    }
  }]);

  return SelectMark;
}(Action);

exports.SelectMark = SelectMark;

var ClearSelection =
/*#__PURE__*/
function (_Action2) {
  _inherits(ClearSelection, _Action2);

  function ClearSelection() {
    _classCallCheck(this, ClearSelection);

    return _possibleConstructorReturn(this, _getPrototypeOf(ClearSelection).apply(this, arguments));
  }

  _createClass(ClearSelection, [{
    key: "digest",
    value: function digest() {
      return {
        name: "ClearSelection"
      };
    }
  }]);

  return ClearSelection;
}(Action);

exports.ClearSelection = ClearSelection;